// import { Box, Card, CardActions, CssBaseline, Grid, Typography, useTheme, Button, IconButton } from '@mui/material';
// import React, { useEffect, useState } from 'react';

// import AppModal from "../../../../../../components/AppModal";
// import InvverterFullSize from "../../../../../../components/inverter/InvverterFullSize";
// import { jsPDF } from "jspdf";
// import "jspdf-autotable"; // Ensure you import the autoTable plugin
// import * as XLSX from "xlsx";
// import logo from '../../../../../../assets/img/logos/logo 2.png';
// import RefreshIcon from '@mui/icons-material/Refresh';
// import { PASS_KEY, WEB_KEY,BaseUrl } from '../../../../../../api/AxiosApi';
// import { InverterPerformanceApi } from '../../../../../../api/Api';
// import ExportExcel from '../../../../../../components/exportExcel/ExportExcel1';
// import { AuthenticationContext } from '../../../../../../context/AuthenticationContext';
// import ExportPdf from '../../../../../../components/exportPdf/ExportPdf';


// // Function to get default dates
// export function getDateTimeForDashboardTab1(date = new Date()) {
//     const formattedCurrentDate = date.toISOString().split("T")[0];
//     const oneDayAgo = new Date(date);
//     oneDayAgo.setDate(oneDayAgo.getDate() - 7);
//     const formattedOneDayAgo = oneDayAgo.toISOString().split("T")[0];
//     return {
//         Today: formattedCurrentDate,
//         LastDay: formattedOneDayAgo,
//     };
// }

// export default function Tab5Inverter1({ ID, TabTitle }) {
//     const { palette, spacing } = useTheme();
//     const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
//     const [logData, setLogData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [error, setError] = useState(null);
//     const [currentPage, setCurrentPage] = useState(1);
//     const [itemsPerPage] = useState(8);
//     const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
//     const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

//     const credentials = {
//         LOGIN_ID: sessionStorage.getItem("LoginID"),
//         LOC_CODE: sessionStorage.getItem("LCODE"),
//         PASS_KEY,
//         WEB_KEY,
//         DT1: StartDate,
//         DT2: EndDate,
//         MTR_NO: ID,
//     };

//     const fetchLogData = async () => {
//         setLoading(true);
//         setError(null);
//         setLogData([]);

//         try {
//             const res = await InverterPerformanceApi(credentials);
//             if (res?.data && Array.isArray(res.data)) {
//                 setLogData(res.data);
//             } else {
//                 setLogData([]);
//             }
//         } catch (err) {
//             // console.error("Error fetching data:", err);
//             setError("Failed to fetch data.");
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchLogData();
//     }, [ID, StartDate, EndDate]);

//     const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials.LOGIN_ID}&LOC_CODE=${credentials.LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`

//     const indexOfLastItem = currentPage * itemsPerPage;
//     const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//     const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);
//     const totalPages = Math.ceil(logData.length / itemsPerPage);

//     const handlePageChange = (pageNumber) => {
//         setCurrentPage(pageNumber);
//     };

//     const excludeKeys = ["NAME", "ID", "EFF", "USR", "KWP"];
//     const filteredLogData = logData.map((item) => {
//         const filteredItem = {};
//         Object.keys(item).forEach((key) => {
//             if (!excludeKeys.includes(key)) {
//                 filteredItem[key] = item[key];
//             }
//         });
//         return filteredItem;
//     });

//     const tableHeaders = filteredLogData.length > 0 ? Object.keys(filteredLogData[0]) : [];

   
//     const exportToExcel = async () => {
//         await ExportExcel(
//             ImageUrl,
//             filteredLogData,
//             StartDate,
//             EndDate,
//             `${TabTitle}_Inverter_Performance`,
//             LoggedInUserInfo
//         );
//     };


//     const exportToPDF = async () => {
//         await ExportPdf(
//             ImageUrl,
//             currentData,
//             StartDate,
//             EndDate,
//             `${TabTitle}_Inverter_Performance`,
//             LoggedInUserInfo,
//             logo,
//             tableHeaders

//         );
//     };

//     const onRefreshData = () => {
//         if (StartDate && EndDate) {
//             fetchLogData();
//         } else {
//             alert("Please provide valid dates");
//         }
//     };

//     return (
//         <>
//             <CssBaseline />
//             <Box bgcolor={'background.default'} py={spacing(1)}>
//                 <div>
//                     <div style={{
//                         marginBottom: "5px",
//                         display: "flex",
//                         justifyContent: "space-between",
//                         alignItems: "center",
//                         gap: "16px",
//                     }}>
//                         <div style={{ marginLeft: "7px", fontSize: "14px" }}>
//                            Inverter Performance
//                         </div>
//                         <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
//                             <label>
//                                 From:&nbsp;
//                                 <input
//                                     type="date"
//                                     value={StartDate}
//                                     onChange={(e) => setStartDate(e.target.value)}
//                                     style={{
//                                         padding: "2px 2px",
//                                         borderRadius: "14px",
//                                         border: "1px solid #ccc",
//                                     }}
//                                 />
//                             </label>
//                             <label>
//                                 To:&nbsp;
//                                 <input
//                                     type="date"
//                                     value={EndDate}
//                                     onChange={(e) => setEndDate(e.target.value)}
//                                     style={{
//                                         padding: "2px 2px",
//                                         borderRadius: "14px",
//                                         border: "1px solid #ccc",
//                                     }}
//                                 />
//                             </label>

//                             {/* <button onClick={onRefreshData} className='button-style'>Show</button> */}
//                             <button onClick={exportToExcel} className='export-button'>Excel</button>
//                             <button onClick={exportToPDF} className='export-button2'>PDF</button>
//                         </div>
//                     </div>

//                     <div className="table-responsive">
//                         <table className="table table-hover table-bordered">
//                             <thead className="text-center">
//                                 <tr>
//                                     <th style={tableHeading}>ID</th>
//                                     <th style={tableHeading}>Date</th>
//                                     <th style={tableHeading}>Total Generation[kWh]</th>
//                                     <th style={tableHeading}>CUF</th>
//                                     <th style={tableHeading}>Peak Generation[kW]</th>
//                                     <th style={tableHeading}>DateTime[MD]</th>
//                                     <th style={tableHeading}>Specific Power</th>
//                                     <th style={tableHeading}>Specific Yield</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {loading ? (
//                                     <tr>
//                                         <td colSpan={8} className="text-center">Loading...</td>
//                                     </tr>
//                                 ) : currentData.length > 0 ? (
//                                     currentData.map((item, rowIndex) => (
//                                         <tr key={rowIndex}>
//                                             <td className="text-center align-middle">{item.MTR ?? ""}</td>
//                                             <td className="text-center align-middle">{item.DATET ?? ""}</td>
//                                             <td className="text-center align-middle">{item.ENG ?? ""}</td>
//                                             <td className="text-center align-middle">{item.CUF ?? ""}</td>
//                                             <td className="text-center align-middle">{item.KW_MAX ?? ""}</td>
//                                             <td className="text-center align-middle">{item.KW_MAX_DATE ?? ""}</td>
//                                             <td className="text-center align-middle">{item.Specific_Power ?? ""}</td>
//                                             <td className="text-center align-middle">{item.Specific_Yield ?? ""}</td>
//                                         </tr>
//                                     ))
//                                 ) : (
//                                     <tr>
//                                         <td colSpan={8} className="text-center">No data available</td>
//                                     </tr>
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>

//                     <div style={{ textAlign: "right", marginTop: "10px" }}>
//                         <button
//                             onClick={() => handlePageChange(currentPage - 1)}
//                             disabled={currentPage === 1}
//                             style={paginationButtonStyle}
//                         >
//                             Previous
//                         </button>

//                         {[...Array(totalPages)].map((_, index) => (
//                             <button
//                                 key={index}
//                                 onClick={() => handlePageChange(index + 1)}
//                                 style={{
//                                     ...paginationButtonStyle,
//                                     backgroundColor: currentPage === index + 1 ? "#356E35" : "white",
//                                     color: currentPage === index + 1 ? "#fff" : "#356E35",
//                                 }}
//                             >
//                                 {index + 1}
//                             </button>
//                         ))}

//                         <button
//                             onClick={() => handlePageChange(currentPage + 1)}
//                             disabled={currentPage === totalPages}
//                             style={paginationButtonStyle}
//                         >
//                             Next
//                         </button>
//                     </div>
//                 </div>
//             </Box>
//         </>
//     );
// }


// /* Styles */

// const containerStyle = {
//     display: "flex",
//     justifyContent: "space-between",
//     alignItems: "center",
//     flexWrap: "wrap",
//     marginBottom: "7px",
//     // border: "1px solid lightgray",
//     padding: "3px",
//     borderRadius: "7px"
// };

// const responsiveHeaderStyle = {
//     fontWeight: "bold",
//     margin: "0",
//     display: "flex",
//     flexWrap: "wrap"
// };

// const responsiveControlsStyle = {
//     display: "flex",
//     flexWrap: "wrap",
//     gap: "10px",
//     justifyContent: "center",
// };

// const inputStyle = {
//     padding: "2px 2px",
//     borderRadius: "14px",
//     border: "1px solid #ccc",
//     // marginLeft: "5px",
//     // fontSize: "10px",
// };

// const buttonStyle = {
//     backgroundColor: "#007BFF",
//     color: "#fff",
//     border: "none",
//     borderRadius: "14px",
//     padding: "2px 9px",
//     cursor: "pointer",
//     fontSize: "10px",
// };

// const exportButtonStyle = {
//     backgroundColor: "darkblue",
//     color: "#fff",
//     border: "none",
//     borderRadius: "14px",
//     padding: "3px 9px",
//     cursor: "pointer",
//     fontSize: "11px",
// };

// const exportButtonStyle2 = {
//     backgroundColor: "#f44336",
//     color: "#fff",
//     border: "none",
//     borderRadius: "14px",
//     padding: "3px 9px",
//     cursor: "pointer",
//     fontSize: "11px",
// };

// const paginationButtonStyle = {
//     backgroundColor: "white",
//     color: "#356E35",
//     border: "1px solid #ddd",
//     padding: "5px 10px",
//     borderRadius: "5px",
//     margin: "0 5px",
//     cursor: "pointer",
//     fontSize: "14px",
// };


// const tableHeading = {
//     color: "rgb(53, 110, 53)",
//     padding: "12px 10px",
//     fontSize: "14px",
//     whiteSpace: "nowrap",
// }

// const tableBody = {
//     padding: "5px",
//     whiteSpace: "nowrap",
// }


import { Box, Card, CardActions, CssBaseline, Grid, Typography, useTheme, Button, IconButton } from '@mui/material';
import React, { useEffect, useState } from 'react';

import AppModal from "../../../../../../components/AppModal";
import InvverterFullSize from "../../../../../../components/inverter/InvverterFullSize";
import { jsPDF } from "jspdf";
import "jspdf-autotable"; // Ensure you import the autoTable plugin
import * as XLSX from "xlsx";
import logo from '../../../../../../assets/img/logos/logo 2.png';
import RefreshIcon from '@mui/icons-material/Refresh';
import { PASS_KEY, WEB_KEY,BaseUrl } from '../../../../../../api/AxiosApi';
import { InverterPerformanceApi } from '../../../../../../api/Api';
import ExportExcel from '../../../../../../components/exportExcel/ExportExcel1';
import { AuthenticationContext } from '../../../../../../context/AuthenticationContext';
import ExportPdf from '../../../../../../components/exportPdf/ExportPdf';


// Function to get default dates
export function getDateTimeForDashboardTab1(date = new Date()) {
    const formattedCurrentDate = date.toISOString().split("T")[0];
    const oneDayAgo = new Date(date);
    oneDayAgo.setDate(oneDayAgo.getDate() - 7);
    const formattedOneDayAgo = oneDayAgo.toISOString().split("T")[0];
    return {
        Today: formattedCurrentDate,
        LastDay: formattedOneDayAgo,
    };
}

export default function Tab5Inverter1({ ID, TabTitle }) {
    const { palette, spacing } = useTheme();
    const { LoggedInUserInfo } = React.useContext(AuthenticationContext)
    const [logData, setLogData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(8);
    const [StartDate, setStartDate] = useState(getDateTimeForDashboardTab1().LastDay);
    const [EndDate, setEndDate] = useState(getDateTimeForDashboardTab1().Today);

    const credentials = {
        LOGIN_ID: sessionStorage.getItem("LoginID"),
        LOC_CODE: sessionStorage.getItem("LCODE"),
        PASS_KEY,
        WEB_KEY,
        DT1: StartDate,
        DT2: EndDate,
        MTR_NO: ID,
    };

    const fetchLogData = async () => {
        setLoading(true);
        setError(null);
        setLogData([]);

        try {
            const res = await InverterPerformanceApi(credentials);
            if (res?.data && Array.isArray(res.data)) {
                setLogData(res.data);
            } else {
                setLogData([]);
            }
        } catch (err) {
            setError("Failed to fetch data.");
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchLogData();
    }, [ID]);

     // Refresh data only when clicking "Show"
     function onRefreshData() {
        if (StartDate.length !== 0 && EndDate.length !== 0) {
            fetchLogData(); // Fetch data only after clicking the button
        } else {
            alert("Please provide valid dates");
        }
    }

    const ImageUrl = `${BaseUrl}CMN_02/GET_COM_LOGO?LOGIN_ID=${credentials.LOGIN_ID}&LOC_CODE=${credentials.LOC_CODE}&PASS_KEY=${PASS_KEY}&WEB_KEY=${WEB_KEY}`

    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentData = logData.slice(indexOfFirstItem, indexOfLastItem);
    const totalPages = Math.ceil(logData.length / itemsPerPage);

    const handlePageChange = (pageNumber) => {
        setCurrentPage(pageNumber);
    };

    // ✅ Define static headers
    const tableHeaders = [
        { label: "ID", key: "MTR" },
        { label: "Date", key: "DATET" },
        { label: "Capacity", key: "KWP" },
        { label: "Total Generation[kWh]", key: "ENG" },
        { label: "CUF", key: "CUF" },
        { label: "PR", key: "PR" },
        { label: "Peak Generation[kW]", key: "KW_MAX" },
        { label: "DateTime[MD]", key: "KW_MAX_DATE" },
        { label: "Specific Power", key: "Specific_Power" },
        { label: "Specific Yield", key: "Specific_Yield" },
        { label: "Solar Insolation", key: "SISO" },
        { label: "Expected[kWh]", key: "EX_GEN" },
    ];

    // ✅ Excel Export
    const exportToExcel = async () => {
        const exportData = logData.map((item) => {
            let row = {};
            tableHeaders.forEach((header) => {
                row[header.label] = item[header.key] ?? "";
            });
            return row;
        });

        await ExportExcel(
            ImageUrl,
            exportData,
            StartDate,
            EndDate,
            `${TabTitle}_Inverter_Performance`,
            LoggedInUserInfo
        );
    };

    // ✅ PDF Export
    const exportToPDF = async () => {
        const exportData = logData.map((item) => {
            let row = {};
            tableHeaders.forEach((header) => {
                row[header.label] = item[header.key] ?? "";
            });
            return row;
        });

        await ExportPdf(
            ImageUrl,
            exportData,
            StartDate,
            EndDate,
            `${TabTitle}_Inverter_Performance`,
            LoggedInUserInfo,
            logo,
            tableHeaders.map(h => h.label) // only headings
        );
    };

    return (
        <>
            <CssBaseline />
            <Box bgcolor={'background.default'} py={spacing(1)}>
                <div>
                    <div style={{
                        marginBottom: "5px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        gap: "16px",
                    }}>
                        <div style={{ marginLeft: "7px", fontSize: "14px" }}>
                            Inverter Performance ({TabTitle})
                        </div>
                        <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                            <label>
                                From:&nbsp;
                                <input
                                    type="date"
                                    value={StartDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    style={inputStyle}
                                />
                            </label>
                            <label>
                                To:&nbsp;
                                <input
                                    type="date"
                                    value={EndDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    style={inputStyle}
                                />
                            </label>
                            <button onClick={onRefreshData} className='button-style' >Show</button>
                            <button onClick={exportToExcel} className='export-button'>Excel</button>
                            <button onClick={exportToPDF} className='export-button2'>PDF</button>
                        </div>
                    </div>

                    <div className="table-responsive">
                        <table className="table table-hover table-bordered">
                            <thead className="text-center">
                                <tr>
                                    {tableHeaders.map((header) => (
                                        <th key={header.key} style={tableHeading}>{header.label}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {loading ? (
                                    <tr>
                                        <td colSpan={tableHeaders.length} className="text-center">Loading...</td>
                                    </tr>
                                ) : currentData.length > 0 ? (
                                    currentData.map((item, rowIndex) => (
                                        <tr key={rowIndex}>
                                            {tableHeaders.map((header) => (
                                                <td key={header.key} className="text-center align-middle">
                                                    {item[header.key] ?? ""}
                                                </td>
                                            ))}
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={tableHeaders.length} className="text-center">No data available</td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>

                    <div style={{ textAlign: "right", marginTop: "10px" }}>
                        <button
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            style={paginationButtonStyle}
                        >
                            Previous
                        </button>

                        {[...Array(totalPages)].map((_, index) => (
                            <button
                                key={index}
                                onClick={() => handlePageChange(index + 1)}
                                style={{
                                    ...paginationButtonStyle,
                                    backgroundColor: currentPage === index + 1 ? "#356E35" : "white",
                                    color: currentPage === index + 1 ? "#fff" : "#356E35",
                                }}
                            >
                                {index + 1}
                            </button>
                        ))}

                        <button
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            style={paginationButtonStyle}
                        >
                            Next
                        </button>
                    </div>
                </div>
            </Box>
        </>
    );
}


/* Styles */

const containerStyle = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    marginBottom: "7px",
    // border: "1px solid lightgray",
    padding: "3px",
    borderRadius: "7px"
};

const responsiveHeaderStyle = {
    fontWeight: "bold",
    margin: "0",
    display: "flex",
    flexWrap: "wrap"
};

const responsiveControlsStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: "10px",
    justifyContent: "center",
};

const inputStyle = {
    padding: "2px 2px",
    borderRadius: "14px",
    border: "1px solid #ccc",
    // marginLeft: "5px",
    // fontSize: "10px",
};

const buttonStyle = {
    backgroundColor: "#007BFF",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "2px 9px",
    cursor: "pointer",
    fontSize: "10px",
};

const exportButtonStyle = {
    backgroundColor: "darkblue",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "3px 9px",
    cursor: "pointer",
    fontSize: "11px",
};

const exportButtonStyle2 = {
    backgroundColor: "#f44336",
    color: "#fff",
    border: "none",
    borderRadius: "14px",
    padding: "3px 9px",
    cursor: "pointer",
    fontSize: "11px",
};

const paginationButtonStyle = {
    backgroundColor: "white",
    color: "#356E35",
    border: "1px solid #ddd",
    padding: "5px 10px",
    borderRadius: "5px",
    margin: "0 5px",
    cursor: "pointer",
    fontSize: "14px",
};


const tableHeading = {
    color: "rgb(53, 110, 53)",
    padding: "12px 10px",
    fontSize: "14px",
    whiteSpace: "nowrap",
}

const tableBody = {
    padding: "5px",
    whiteSpace: "nowrap",
}